import type { CustomViewTarget } from './customViewConfig'
import { ProductsContext } from './ProductsContext'
import { useProducts } from './useProducts'

export function ProductsProvider({
  children,
  target = 'gallery',
}: Readonly<{
  children: React.ReactNode
  target?: CustomViewTarget
}>) {
  const value = useProducts(target)

  return (
    <ProductsContext value={value}>
      {children}
    </ProductsContext>
  )
}
